/**
 * Created by eriksundqvist on 12/10/16.
 */
import * as type from './action-types';

const initialState = {
  firstName: null,
  lastName: null,
  email: null,
  cellphone: null,
  co: null,
  street: null,
  zip: null,
  city: null,
  country: null,
  professionTitle: null,
  socialSecurityNumber: null,
  accountClearingNumber: null,
  accountNumber: null,
  bankgiro: null,
  postgiro: null,
  bic: null,
  iban: null,
  internationalAccount: null,
  showNameInNetwork: null,
  saveVacationPay: null,
  saveItp: null,
  displayHsd: null,
  prefferedPaymentTypeId: null,
  receiveSmsNotifications: null,
  receiveEmailNotifications: null,
  notificationLanguage: null,
  remoteId: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.SET_FIRST_NAME:
      return Object.assign({}, state, {
        firstName: action.payload
      });

    case type.SET_LAST_NAME:
      return Object.assign({}, state, {
        lastName: action.payload
      });

    case type.SET_EMAIL:
      return Object.assign({}, state, {
        email: action.payload
      });

    case type.SET_CELLPHONE:
      return Object.assign({}, state, {
        cellphone: action.payload
      });

    case type.SET_CO:
      return Object.assign({}, state, {
        co: action.payload
      });

    case type.SET_ZIP:
      return Object.assign({}, state, {
        zip: action.payload
      });

    case type.SET_STREET:
      return Object.assign({}, state, {
        street: action.payload
      });

    case type.SET_CITY:
      return Object.assign({}, state, {
        city: action.payload
      });

    case type.SET_COUNTRY:
      return Object.assign({}, state, {
        country: action.payload
      });

    case type.SET_PROFESSION_TITLE:
      return Object.assign({}, state, {
        professionTitle: action.payload
      });

    case type.SET_SOCIAL_SECUTIRY_NUMBER:
      return Object.assign({}, state, {
        socialSecurityNumber: action.payload
      });

    case type.SET_ACCOUNT_CLEARING_NUMBER:
      return Object.assign({}, state, {
        accountClearingNumber: action.payload
      });

    case type.SET_ACCOUNT_NUMBER:
      return Object.assign({}, state, {
        accountNumber: action.payload
      });

    case type.SET_BANKGIRO:
      return Object.assign({}, state, {
        bankgiro: action.payload
      });

    case type.SET_POSTGIRO:
      return Object.assign({}, state, {
        postgiro: action.payload
      });

    case type.SET_BIC:
      return Object.assign({}, state, {
        bic: action.payload
      });

    case type.SET_IBAN:
      return Object.assign({}, state, {
        iban: action.payload
      });

    case type.SET_INTERNATIONAL_ACCOUNT:
      return Object.assign({}, state, {
        internationalAccount: action.payload
      });

    case type.SET_SHOW_NAME_IN_NETWORK:
      return Object.assign({}, state, {
        showNameInNetwork: action.payload
      });

    case type.SET_SAVE_VACATION_PAY:
      return Object.assign({}, state, {
        saveVacationPay: action.payload
      });

    case type.SET_SAVE_ITP:
      return Object.assign({}, state, {
        saveItp: action.payload
      });

    case type.SET_ITP_RATE:
      return Object.assign({}, state, {
        itpRate: action.payload
      });

    case type.SET_DISPLAY_HSD:
      return Object.assign({}, state, {
        displayHsd: action.payload
      });

    case type.SET_PREFFERED_PAYMENT_TYPE_ID:
      return Object.assign({}, state, {
        prefferedPaymentTypeId: action.payload
      });

    case type.SET_RECEIVE_SMS_NOTIFICATIONS:
      return Object.assign({}, state, {
        receiveSmsNotifications: action.payload
      });

    case type.SET_RECEIVE_EMAIL_NOTICATIONS:
      return Object.assign({}, state, {
        receiveEmailNotifications: action.payload
      });

    case type.SET_NOTIFICATION_LANGUAGE:
      return Object.assign({}, state, {
        notificationLanguage: action.payload
      });

    case type.SET_REMOTE_ID:
      return Object.assign({}, state, {
        remoteId: action.payload
      });

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/workers/reducer.js
 **/